import React from 'react';
import { ColumnDescription } from 'react-bootstrap-table-next';
import useAsyncEffect from '../../../hooks/useAsyncEffect';
import Table from '../../../Components/Table';
import usePaginationFilter from '../../../hooks/usePaginationFilter';
import { getXMonthsAgoDate } from '../../../Tools/DateTools';
import StorageManagerCapys from '../../../Tools/Storage';
import SpinnerComponent from '../../../Components/Loding/Spinner';
import TitulosFilter from './TitulosFiltro';
import { ITitulos } from '../../../Interfaces/Cobranca/Titulos/TitulosInterface';
import { ListarTitulosCobrancaController, ListarTitulosCobrancaExportarExcelController } from '../../../Controllers/Cobranca/Titulos/TitulosControllers';
import ExportExcel from '../../../Components/StickyToolbar/ExportExcel';

const filterStorage = new StorageManagerCapys<Omit<ITitulos, "NR_PAGINA">>("FILTRO_GESTAO_COBRANCA_TITULOS");


export function GestaoTitulos() {

    const todaysDate = new Date()

    const { PageFilter, setPage, setPageFilter, filter } = usePaginationFilter<ITitulos>({ 
        page: 1, filter: {
            DT_MES_REFERENCIA_INICIO: getXMonthsAgoDate(5).toISOString(), 
            DT_MES_REFERENCIA_FIM: todaysDate.toISOString(), 
            DT_VENCIMENTO_INICIO: getXMonthsAgoDate(5).toISOString(), 
            DT_VENCIMENTO_FIM: todaysDate.toISOString(), 
            ID_EMPRESA: 0, 
            ID_OBRA: '', 
            ID_VENDA: 0,
            ID_TIPO_PARCELA: '',
            DS_CLIENTE: '',
            DS_IDENTIFICADOR: '',
            DS_CLASSIFICACAO_CONTRATO: ''
        } 
    });

    const {
        value: lstTitulos,
        loading: lstTitulosLoading,
    } = useAsyncEffect(async () => {

        const res = await ListarTitulosCobrancaController({
            ...(PageFilter.filter),
            DS_CLASSIFICACAO_CONTRATO: PageFilter.filter?.DS_CLASSIFICACAO_CONTRATO ?? '',
            DS_CLIENTE: PageFilter.filter?.DS_CLIENTE ?? '',
            DS_IDENTIFICADOR: PageFilter.filter?.DS_IDENTIFICADOR ?? '',
            DT_MES_REFERENCIA_FIM: PageFilter.filter?.DT_MES_REFERENCIA_FIM ?? '',
            DT_MES_REFERENCIA_INICIO: PageFilter.filter?.DT_MES_REFERENCIA_INICIO ?? '',
            DT_VENCIMENTO_FIM: PageFilter.filter?.DT_VENCIMENTO_FIM ?? '',
            DT_VENCIMENTO_INICIO: PageFilter.filter?.DT_MES_REFERENCIA_INICIO ?? '',
            ID_EMPRESA: PageFilter.filter?.ID_EMPRESA ?? 0,
            ID_OBRA: PageFilter.filter?.ID_OBRA ?? '',
            ID_TIPO_PARCELA: PageFilter.filter?.ID_TIPO_PARCELA ?? '',
            ID_VENDA: PageFilter.filter?.ID_VENDA ?? 0,
            PAGINA: PageFilter.page,

        })

        return res;

    }, [PageFilter]);


    const totalPaginas = lstTitulos?.NR_PAGINAS || 1;



    return (
        <>
            <>
                <div className="card card-custom w-auto gutter-b m-5" >
                    {lstTitulos ?
                        (<Table
                            wrapperClasses="mw-100 custom-scroll"
                            columns={tableviewColumns}
                            data={lstTitulos.Titulos}
                            keyField='ID_CASO_COBRANCA_FATO_PARCELAS'
                            onTableChange={(type, newState) => {
                                setPage(newState.page)
                            }}
                            remote={{ pagination: true }}
                            totalPages={totalPaginas}
                            loading={lstTitulosLoading}
                            noDataIndication={() => <div className="text-black-50 text-center">Nenhum Título encontrado</div>}
                            noHover
                            noSearch
                            bordered={false}
                            classes='v-middle-cells'
                            defaultStyle={{align: 'center'}}
                            striped={true}
                            rowClasses={'rowClasses'}
                            paginationColor={'Cobranca'}
                        />
                        )
                        : (lstTitulosLoading ? <SpinnerComponent />
                            : (<div className="text-muted text-center">
                                Erro ao carregar dados
                            </div>)
                        )}
                </div>
            </>
            <TitulosFilter
                handleSubmit={formData => {
                    setPageFilter({
                        filter: formData,
                        page: 1
                    })
                }}
                storageManager={filterStorage}
                defaultFilter={filter} 
            />
            <ExportExcel
                baixarExcelController={async () =>
                    ListarTitulosCobrancaExportarExcelController({
                        ...(PageFilter.filter),
                        DS_CLASSIFICACAO_CONTRATO: PageFilter.filter?.DS_CLASSIFICACAO_CONTRATO ?? '',
                        DS_CLIENTE: PageFilter.filter?.DS_CLIENTE ?? '',
                        DS_IDENTIFICADOR: PageFilter.filter?.DS_IDENTIFICADOR ?? '',
                        DT_MES_REFERENCIA_FIM: PageFilter.filter?.DT_MES_REFERENCIA_FIM ?? '',
                        DT_MES_REFERENCIA_INICIO: PageFilter.filter?.DT_MES_REFERENCIA_INICIO ?? '',
                        DT_VENCIMENTO_FIM: PageFilter.filter?.DT_VENCIMENTO_FIM ?? '',
                        DT_VENCIMENTO_INICIO: PageFilter.filter?.DT_MES_REFERENCIA_INICIO ?? '',
                        ID_EMPRESA: PageFilter.filter?.ID_EMPRESA ?? 0,
                        ID_OBRA: PageFilter.filter?.ID_OBRA ?? '',
                        ID_TIPO_PARCELA: PageFilter.filter?.ID_TIPO_PARCELA ?? '',
                        ID_VENDA: PageFilter.filter?.ID_VENDA ?? 0,
                        PAGINA: 0
                    })
                }
                nomeArquivo={"Titulos_Cobranca"}
            />
        </>
    )
}

const tableviewColumns: Array<ColumnDescription> = [{
    dataField: 'DUMMY_FIELD',
    text: '',
    isDummyField: true,
}, {
    dataField: 'ID_EMPRESA',
    text: "Empresa",
    align: 'center'
}, {
    dataField: 'ID_OBRA',
    text: "Obra",
    align: 'center'
}, {
    dataField: 'ID_VENDA',
    text: "Venda",
    align: 'center'
}, {
    dataField: 'ID_PARCELA',
    text: "Nr. Parcela",
    align: 'center'
}, {
    dataField: 'ID_TIPO_PARCELA',
    text: "Tipo Parcela",
    align: 'center'
}, {
    dataField: 'ID_PARCELA_GERAL',
    text: "Nr. Parcela Geral",
    align: 'center'
}, {
    dataField: 'DS_CLIENTE',
    text: "Cliente",
    align: 'center'
}, {
    dataField: 'DS_IDENTIFICADOR',
    text: "Quadra/Lote",
    align: 'center'
}, {
    dataField: 'DS_CLASSIFICACAO_CONTRATO',
    text: "Classificação",
    align: 'center'
}, {
    dataField: 'DT_VENCIMENTO',
    text: "Data de Vencimento",
    align: 'center',
    formatter: (c) => new Date(c).toLocaleString()
}, {
    dataField: 'NR_AGING_PARCELA',
    text: "Aging Vencimento",
    align: 'center'
}, {
    dataField: 'DT_PRORROGACAO',
    text: "Data Prorrogação",
    align: 'center',
    formatter: (c) => new Date(c).toLocaleString()
}, {
    dataField: 'NR_AGING_PARCELA_PRORROGACAO',
    text: "Aging Prorrogação",
    align: 'center'
}, {
    dataField: 'VL_PARCELA',
    text: "Vl. Parcela",
    align: 'center'
}, {
    dataField: 'VL_PARCELA_PRINCIPAL',
    text: "Vl. Principal",
    align: 'center'
}, {
    dataField: 'VL_JUROS_ATRASO',
    text: "Vl. Juros",
    align: 'center'
}, {
    dataField: 'VL_MULTA_ATRASO',
    text: "Vl. Multa",
    align: 'center'
}, {
    dataField: 'VL_CORRECAO_ATRASO',
    text: "Vl. Correção",
    align: 'center'
}, {
    dataField: 'DS_INDICE_REAJUSTE',
    text: "Índice Reaj.",
    align: 'center'
}]